const presentation_video_element = document.querySelector('#Presentation');
const slides_container = document.querySelector('#SlidesContainer');
const sphere_container = document.querySelector('#SphereContainer');

if( presentation_video_element && slides_container && sphere_container ) {

  const videoController = new VideoControler( presentation_video_element );
  const sphereControler = new SphereControler( sphere_container );
  const slideControler = new SlideControler( slides_container );
    slideControler.connect_videocontroler(videoController);
    slideControler.start();

  window.slideControler = slideControler; // beschikbaar voor andere files

}

//
// Responsive video source
//

(function() {

  var currentsource = false;
  const video = document.getElementById('Presentation');

  if( video && (video != undefined) && (video != null) ) {
    const smallSrc = 'https://video.gumlet.io/67af00aae5de6394b226f2d7/67af475de5de6394b22880f6/download.mp4';
    const largeSrc = 'https://video.gumlet.io/67af00aae5de6394b226f2d7/67af475875234820eae84ddf/download.mp4';

    function updateVideoSource( init ) {
      if (window.innerWidth < 1200) { // mobile

        if( currentsource == false || currentsource != smallSrc ) {
          let currenttime = video.currentTime;
          let is_playing = (video.currentTime > 0) && (!video.paused) && (!video.ended);
          currentsource = smallSrc;
          video.src = smallSrc;
          video.currentTime = currenttime;
          video.load();
          if( is_playing || init ) video.play();
        }

      } else { // desktop

        if( currentsource == false || currentsource != largeSrc ) {
          let currenttime = video.currentTime;
          let is_playing = (video.currentTime > 0) && (!video.paused) && (!video.ended);
          currentsource = largeSrc;
          video.src = largeSrc;
          video.currentTime = currenttime;
          video.load();
          if( is_playing || init ) video.play();
        }

      }
    }

    currentsource = video.src;
    updateVideoSource(true);

    window.onresize = function() {
      updateVideoSource(false);
    };
  }

})();